/**
 * MW STUFFS - Pify Size Chart Button Relocator
 *
 * Moves the Pify Size Chart button from its standalone block position
 * into the MW Variant Pills "Size" label area (top-right corner).
 *
 * Why a separate file: the Pify block renders independently, so we need
 * to wait for it to be in DOM. We poll briefly with retries.
 */
(function () {
  let moved = false;
  let attempts = 0;
  const MAX_ATTEMPTS = 20; // ~6 seconds total
  const RETRY_DELAY = 300;

  function findPifyButton() {
    // Selectors based on actual Pify rendered DOM (verified via DevTools inspection)
    const selectors = [
      // Primary: actual Pify class names with underscores
      '.pify_size_chart_wrapper',
      '.pify_inline_button',
      '.pify-overlay-button',
      // Other common Pify variants
      '[class*="pify_size_chart"]',
      '[class*="pify_inline"]',
      '[class*="pify-size-chart"]',
      '[class*="pify-overlay"]',
      '[id*="pify_size_chart"]',
      '[id*="pify-size-chart"]',
      '[data-pify-size-chart]',
      // App block container fallback
      '.shopify-block[id*="pify"]',
      '.shopify-block[class*="pify"]',
    ];

    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) {
        // Make sure it's not already inside our variant pills (already moved)
        if (el.closest('.mw-pill-label__chart-link')) continue;
        return el;
      }
    }

    // Text-based fallback: find a button/link with "Size Chart" text inside an app block
    const appBlocks = document.querySelectorAll('.shopify-block, [class*="shopify-app-block"]');
    for (const block of appBlocks) {
      if (block.closest('.mw-pill-label__chart-link')) continue;
      const text = (block.textContent || '').trim().toLowerCase();
      if (text === 'size chart' || text.includes('size chart')) {
        if (block.closest('variant-pills')) continue;
        if (block.closest('.mw-variant-pills')) continue;
        return block;
      }
    }

    return null;
  }

  function findSizeLabel() {
    // Find the SIZE option's label inside MW Variant Pills
    const groups = document.querySelectorAll('.mw-pill-group');
    for (const group of groups) {
      const label = group.querySelector('.mw-pill-label');
      if (!label) continue;
      const text = label.textContent.toLowerCase();
      // Match "size" anywhere in the label (case-insensitive)
      if (text.includes('size')) return label;
    }
    return null;
  }

  function tryRelocate() {
    if (moved) return;
    attempts++;

    const pifyBtn = findPifyButton();
    const sizeLabel = findSizeLabel();

    if (!pifyBtn || !sizeLabel) {
      if (attempts < MAX_ATTEMPTS) {
        setTimeout(tryRelocate, RETRY_DELAY);
      } else {
        console.log('[MW Pify] Gave up. pifyBtn:', !!pifyBtn, 'sizeLabel:', !!sizeLabel);
      }
      return;
    }

    // Wrap the Pify button with a positioning container and append to size label
    const wrapper = document.createElement('span');
    wrapper.className = 'mw-pill-label__chart-link';
    wrapper.appendChild(pifyBtn);
    sizeLabel.appendChild(wrapper);
    moved = true;
    console.log('[MW Pify] Size chart button relocated to size label');
  }

  // Start polling once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryRelocate);
  } else {
    tryRelocate();
  }
})();